import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen, Shield, Lock } from 'lucide-react';

const PaymentLayout = ({ children }) => {
  const location = useLocation();
  const isCheckout = location.pathname.includes('/checkout') || location.pathname.includes('/success') || location.pathname.includes('/cancel');

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f8fafc] to-[#e2e8f0] flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/payment" className="flex items-center gap-2">
            <div className="bg-blue-600 p-2 rounded-lg">
              <BookOpen className="h-5 w-5 text-white" />
            </div>
            <span className="text-lg font-bold text-gray-900">FormaPro Digital</span>
          </Link>
          {!isCheckout && (
            <nav className="hidden md:flex items-center gap-6 text-sm">
              <Link to="/payment" className="text-gray-600 hover:text-blue-600 transition-colors">Accueil</Link>
              <Link to="/payment/product" className="text-gray-600 hover:text-blue-600 transition-colors">Formation</Link>
              <Link to="/payment/cgv" className="text-gray-600 hover:text-blue-600 transition-colors">CGV</Link>
              <Link to="/payment/mentions-legales" className="text-gray-600 hover:text-blue-600 transition-colors">Mentions légales</Link>
            </nav>
          )}
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <Lock className="h-3 w-3" />
            <span>Paiement sécurisé</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="flex-grow">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
            <div>
              <div className="flex items-center gap-2 mb-3">
                <BookOpen className="h-4 w-4 text-blue-600" />
                <span className="font-semibold text-gray-900">FormaPro Digital</span>
              </div>
              <p className="text-sm text-gray-500">Formation en e-commerce digital. Contenu pédagogique de qualité pour développer vos compétences.</p>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-3 text-sm">Informations légales</h4>
              <div className="space-y-2">
                <Link to="/payment/cgv" className="block text-sm text-gray-500 hover:text-blue-600">Conditions générales de vente</Link>
                <Link to="/payment/mentions-legales" className="block text-sm text-gray-500 hover:text-blue-600">Mentions légales</Link>
                <Link to="/payment/confidentialite" className="block text-sm text-gray-500 hover:text-blue-600">Politique de confidentialité</Link>
              </div>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-3 text-sm">Sécurité</h4>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <Shield className="h-4 w-4 text-green-600" />
                <span>Paiement sécurisé par Stripe</span>
              </div>
              <p className="text-xs text-gray-400 mt-2">Vos données de paiement sont traitées de manière sécurisée. Nous ne stockons jamais vos informations bancaires.</p>
            </div>
          </div>
          <div className="border-t border-gray-100 pt-4 text-center text-xs text-gray-400">
            © {new Date().getFullYear()} FormaPro Digital. Tous droits réservés.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PaymentLayout;
